import { combineReducers } from 'redux';
import { createSelector } from 'reselect';

import * as actions from '../actions';
import { getUserById } from './users';

function byId(state = {}, action) {
  switch (action.type) {
    case actions.REQUEST_COMPANY_BUDGETS_START:
    case actions.REQUEST_COMPANY_BUDGETS_ERROR:
      return {};
    case actions.REQUEST_COMPANY_BUDGETS_SUCCESS:
    case actions.CREATE_COMPANY_BUDGET_SUCCESS:
    case actions.UPDATE_COMPANY_BUDGET_SUCCESS:
      return Object.assign({}, state, action.data.entities.budgets);
    default:
      return Object.assign({}, state);
  }
}

function loading(state = false, action) {
  switch (action.type) {
    case actions.REQUEST_COMPANY_BUDGETS_START:
    case actions.CREATE_COMPANY_BUDGET_START:
    case actions.UPDATE_COMPANY_BUDGET_START:
      return true;
    case actions.REQUEST_COMPANY_BUDGETS_SUCCESS:
    case actions.REQUEST_COMPANY_BUDGETS_ERROR:
    case actions.CREATE_COMPANY_BUDGET_SUCCESS:
    case actions.CREATE_COMPANY_BUDGET_ERROR:
    case actions.UPDATE_COMPANY_BUDGET_SUCCESS:
    case actions.UPDATE_COMPANY_BUDGET_ERROR:
      return false;
    default:
      return state;
  }
}

function error(state = null, action) {
  switch (action.type) {
    case actions.REQUEST_COMPANY_BUDGETS_START:
    case actions.REQUEST_COMPANY_BUDGETS_SUCCESS:
    case actions.CREATE_COMPANY_BUDGET_START:
    case actions.UPDATE_COMPANY_BUDGET_START:
    case actions.CREATE_COMPANY_BUDGET_SUCCESS:
    case actions.UPDATE_COMPANY_BUDGET_SUCCESS:
      return null;
    case actions.REQUEST_COMPANY_BUDGETS_ERROR:
    case actions.CREATE_COMPANY_BUDGET_ERROR:
    case actions.UPDATE_COMPANY_BUDGET_ERROR:
      return action.err.message || process.env.ERR_GENERIC;
    default:
      return state;
  }
}

const budgets = combineReducers({
  byId,
  loading,
  error,
});

export default budgets;

export const getBudgetById = (state, id) => {
  const $budget = state.budgets.byId[id];

  return $budget && Object.assign({}, $budget, {
    owner: getUserById(state, $budget.owner),
  });
};

export const getBudgetsByIds = (state, ids) =>
  (ids || []).map(id => getBudgetById(state, id));

const $getLoading = state => state.budgets.loading;

export const getLoading = createSelector(
  $getLoading,
  $loading => $loading);
